import React from 'react';
import {
  Container,
  Typography,
  Box,
  AppBar,
  Toolbar,
  Button,
  Paper,
  IconButton,
  Grid,
} from '@mui/material';
import { QrCode2, ArrowBack, Home, Email, Phone, LocationOn } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
      <AppBar position="static" color="primary" elevation={0} sx={{ bgcolor: '#1F425C' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={handleBack}
            sx={{ mr: 2, color: '#fff' }}
          >
            <ArrowBack />
          </IconButton>
                      <img src="/HINDALCO.NS_BIG.png" alt="Hindalco" style={{ marginRight: '16px', height: '32px', width: 'auto' }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: '#fff', fontWeight: 500 }}>
            Contact Us - Hindalco QR Management
          </Typography>
          <Button
            color="inherit"
            startIcon={<Home />}
            onClick={handleHome}
            sx={{
              ml: 2,
              color: '#fff',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Home
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ mt: 4, mb: 12, pb: 4 }}>
        <Paper elevation={2} sx={{
          p: { xs: 3, sm: 4, md: 6 },
          borderRadius: 3,
          bgcolor: '#fff',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        }}>
          <Typography variant="h3" sx={{ 
            color: '#1F425C', 
            fontWeight: 600, 
            mb: 4,
            textAlign: 'center'
          }}>
            Contact Us
          </Typography>

          <Typography variant="body1" sx={{ 
            mb: 6, 
            textAlign: 'center', 
            lineHeight: 1.7, 
            color: '#555',
            fontSize: '1.1rem'
          }}>
            [Content to be added by admin - General contact information and introduction]
          </Typography>

          <Grid container spacing={4} sx={{ mb: 6 }}>
            <Grid item xs={12} md={4}>
              <Box sx={{ 
                textAlign: 'center', 
                p: 3, 
                bgcolor: '#f8f9fa', 
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <Email sx={{ fontSize: 48, color: '#1F425C', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 1 }}>
                  Email
                </Typography>
                <Typography variant="body1" sx={{ color: '#555' }}>
                  [Email to be added]
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ 
                textAlign: 'center', 
                p: 3, 
                bgcolor: '#f8f9fa', 
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <Phone sx={{ fontSize: 48, color: '#1F425C', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 1 }}>
                  Phone
                </Typography>
                <Typography variant="body1" sx={{ color: '#555' }}>
                  [Phone number to be added]
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ 
                textAlign: 'center', 
                p: 3, 
                bgcolor: '#f8f9fa', 
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <LocationOn sx={{ fontSize: 48, color: '#1F425C', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 1 }}>
                  Address
                </Typography>
                <Typography variant="body1" sx={{ color: '#555' }}>
                  [Address to be added]
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Support Hours
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Support hours and availability]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Technical Support
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Technical support contact information and procedures]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Emergency Contact
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Emergency contact procedures for critical issues]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Feedback & Suggestions
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - How users can provide feedback about the QR management system]
            </Typography>
          </Box>

          <Box sx={{ 
            mt: 6, 
            p: 3, 
            bgcolor: '#f8f9fa', 
            borderRadius: 2,
            border: '1px dashed #dee2e6'
          }}>
            <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              📝 Admin Note
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              This is a template page. Please replace the placeholder content above with your actual contact information. 
              Include specific email addresses, phone numbers, office addresses, and support procedures relevant to your 
              QR management system and organization.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactPage; 